const ItemsSortMethod = {
	CUSTOM: 'custom',
	NEWEST_FIRST: 'newest_first',
	OLDEST_FIRST: 'oldest_first',
} as const;

export default ItemsSortMethod;
